module.exports = __webpack_public_path__ + "private_en@2x.f95c972d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/ClassOne/images/private_en@2x.png
// module id = OG2L
// module chunks = 0